import React from 'react';
import Page from "../Page";
import $ from "jquery";
import { notify } from "react-notify-toast";
import { Link } from "react-router-dom";
import {
	Row,
	Button,
   Tab,
   Tabs
} from "react-materialize";
import "../../styles/referral.css";
import { API_REFERRAL, API_TERM_POINTS,API_TERM_BONUS,API_TOTAL_POINT,API_IS_REFERRAL,API_DETAIL_PROFILE, API_PULSA_DETAIL, API_BASE_URL, BASE_URL } from "../Util";
import { ShareButtons } from "react-share";
import FontAwesome from "react-fontawesome";

class Referral extends Page {
   constructor(props) {
		super(props);
		this.state = {
         skema: 0,
         scrolled: false,
         status_referral:"",
         referral:"",
         points:[],
         bonus:[],
         total_benefit:"",
         total_bonus:"",
         total_point:"",
         total_pulsa:"",
         no_handphone:""
		};
      this.onTabChange = this.onTabChange.bind(this);
	}


   componentDidMount(){
      console.log('cek props', this.props.location.state);
      if(this.props.location.state != undefined){
         this.setState({skema : this.props.location.state.skema})
      }
      Promise.all([
         this.handleIsReferral(),
         this.handleReferral(),
         this.handleTermPoints(),
         this.handleTermBonus(),
         this.handleTotalBonus(),
         this.handleNoHandphone(),
         this.handleTotalPulsa(),
      ]).then(() => {
         console.log('cek skema', window.location);
         if( this.state.skema == 1 ){
            let id = 'skema'
            if(window.location.hash == "#tab_1"){
               id = 'skema-2'
            }
            setTimeout(() => {
               document.getElementById(id).scrollIntoView({
                  behavior:"smooth",
                  block:"start",
                  inline: "nearest"
               })
            }, 300)
         } 
      })
   }
   onTabChange = tabNumber => {
		console.log(tabNumber);
	};

   handleNoHandphone = e =>{
      return $.post(API_DETAIL_PROFILE).then(data => {
         this.setState({no_handphone: data.payload.data[0].phone});
      })
   }

   handleTotalPulsa(){
      $.get(API_PULSA_DETAIL).then(result => {
         let data = result.data;
         this.setState({
            total_pulsa: data.total_pulsa,
         })
      })
   }

   handleIsReferral(){
		return $.get(API_IS_REFERRAL).then(data => {
			console.log('isReferral', data.status)
			this.setState({status_referral : data.status});
         if (this.state.status_referral != true){
            this.props.history.push("/")
         }
		})
	}

   handleReferral(){
      return $.get(API_REFERRAL).then(data => {
         console.log('referral',data);
         this.setState({referral:data.payload})
      })
   }

   handleTotalBonus(){
      return $.get(API_TOTAL_POINT).then(data => {
         console.log('total_benefit', data.data.total_benefit)
         this.setState({
            total_benefit: data.data.total_benefit, 
            total_bonus: data.data.total_bonus,
            total_point: data.data.total_point,
         })
      })
   }

   handleTermPoints(){
      return $.get(API_TERM_POINTS).then(data => {
         console.log('points', data.payload);
         this.setState({points:data.payload})
      })
   }

   handleTermBonus(){
      return $.get(API_TERM_BONUS).then(data => {
         console.log('bonus', data.payload)
         this.setState({bonus:data.payload})
      })
   }

   render() {
      let {referral, bonus, total_benefit, total_bonus,total_point,total_pulsa, no_handphone} = this.state;
      
      return (
         <div className="bg-white no-shadow container pad-m ">
            <div className="nav-wrapper">
            <Tabs className="no-shadow container" onChange={this.onTabChange}>
						<Tab className="col s6" title="Pemilik Kode">
							<TabContent
								// items={data.enrolled_courses}
                        referral={referral}
                        total_point={total_point}
                        bonus={bonus}
								type="benefit"
								emptyImage="img/profile-course-empty.png"
								emptyText="Meja Belajar Anda masih kosong"
							/>
						</Tab>

						<Tab className="col s6" title="Pengguna Kode">
							<TabContent
								// items={data.enrolled_courses}
                        total_pulsa={total_pulsa}
                        no_handphone={no_handphone}
                        referral={referral}
                        total_point={total_point}
                        bonus={bonus}
								type="bonus"
								emptyImage="img/profile-favorite-empty.png"
								// emptyText={`Belum ada ${trans.course} yang Anda simpan`}
							/>
						</Tab>
					</Tabs>
            </div>
         </div>

      )
   }
}

class TabContent extends React.Component {
   render() {
      let referral = this.props.referral
      let total_point = this.props.total_point
      let bonus = this.props.bonus
      let type = this.props.type
      let no_handphone = this.props.no_handphone
      let total_pulsa = this.props.total_pulsa
      console.log('cek bonus', bonus)
      return (
         <Row>
           {
              type == "benefit" ? 
               <Benefit 
                  referral={referral}
                  total_point={total_point}
                  bonus={bonus} 
               /> 
              : 
               <Bonus
                  total_pulsa={total_pulsa}
                  no_handphone={no_handphone}
                  referral={referral}
                  total_point={total_point}
                  bonus={bonus} 
               />
           }
         </Row>
      )
   }
}

class Benefit extends React.Component {

   getTableSkema1 = () => {
      let bonus = this.props.bonus
      var tableSkema1 = (
         <table 
            className="mt-s"
         >
            <thead style={{backgroundColor:'#303b92'}}>
               <tr>
                  <th className="text-center text-white">Harga Kelas</th>
                  <th className="text-center text-white">Uang yang kamu dapatkan</th>
               </tr>
            </thead>
            {bonus.map((bonus,index)=>{
               if(bonus.schema == 1){
                  if ( index%2 == 0){
                     return(
                        <tbody>
                           <tr style={{ backgroundColor:'#546dfc'}}>
                              <td style={{ width:'300px'}}className="text-center text-white">Rp {bonus.price_from} - Rp {bonus.price_to}</td>
                              <td style={{ width:'300px'}}className="text-center text-white">Rp {bonus.buyers_point}</td>
                           </tr>
                        </tbody>
                     )
                  } else {
                     return(
                        <tbody>
                           <tr style={{ backgroundColor:'#4a65d8'}}>
                              <td className="text-center text-white">Rp {bonus.price_from} - Rp {bonus.price_to}</td>
                              <td className="text-center text-white">Rp {bonus.buyers_point}</td>
                           </tr>
                        </tbody>
                     )
                  }
               }
            })}
         </table>
      )
      return tableSkema1
   }

   getTableSkema2 = () => {
      let bonus = this.props.bonus
      var tableSkema2 = (
         <table 
            className="mt-s"
         >
            <thead style={{backgroundColor:'#303b92'}}>
               <tr>
                  <th className="text-center text-white">Harga Kelas</th>
                  <th className="text-center text-white">Uang yang kamu dapatkan</th>
               </tr>
            </thead>
            {bonus.map((bonus,index)=>{
               if(bonus.schema == 2){
                  if ( index%2 == 0){
                     return(
                        <tbody>
                           <tr style={{ backgroundColor:'#546dfc'}}>
                              <td style={{ width:'300px'}}className="text-center text-white">Rp {bonus.price_from} - Rp {bonus.price_to}</td>
                              <td style={{ width:'300px'}}className="text-center text-white">Rp {bonus.buyers_point}</td>
                           </tr>
                        </tbody>
                     )
                  } else {
                     return(
                        <tbody>
                           <tr style={{ backgroundColor:'#4a65d8'}}>
                              <td className="text-center text-white">Rp {bonus.price_from} - Rp {bonus.price_to}</td>
                              <td className="text-center text-white">Rp {bonus.buyers_point}</td>
                           </tr>
                        </tbody>
                     )
                  }
               }
            })}
         </table>
      )
      return tableSkema2
   }

   render() {
      let referral = this.props.referral
      let total_point = this.props.total_point
      let bonus = this.props.bonus
      const { 
         TwitterShareButton,
         TelegramShareButton,
         WhatsappShareButton, 
      } = ShareButtons;
      var shareUrl = ` ` ;
      var shareContent = 'Saya sudah daftar di Geti. \nSilahkan gunakan kode referral saya ' + referral;
      return(
            <Row>
               <h4 className="text-center mt-m" style={{ color: "black" }}>Bagikan kode referralmu dan dapatkan <br />jutaan rupiah tiap minggunya!</h4>
               <h4 
                  className="text-center mt-m " 
                  style={{ color: "black", fontWeight: "100" }}
               > 
                  Kode Referral Kamu
               </h4>
               <div 
                  className="input-field" 
                  style={{
                     display: 'flex',
                     justifyContent:'center',
                     alignItems:'center'
                  }} 
               >
                  <input value={referral} style={{ width: '400px', color: 'black', fontSize:"21px"}} placeholder="Kode Referral kamu" disabled />
                  <span 
                     style={{ cursor: 'pointer'}}
                     className="material-icons"
                     onClick={() => {
                        navigator.clipboard.writeText(this.props.referral)
                           .then(() => {
                              notify.show('kode referral telah tersalin', "success");
                              })
                           }
                     }>content_copy
                  </span>
               </div>
               <div 
                  style={{
                     display: 'flex',
                     justifyContent:'center',
                     alignItems:'center'
                  }}
               >
                  <div className="bg-light-grey fixed-bottom">
                     <div className="pad-m-s container-medium center-s">
                        <span className="h5 font-grey mr-s hide-on-small-only">
                           Bagikan ke
                        </span>
                        <h5 className="font-grey hide-on-med-and-up mb-s">Bagikan ke</h5>
                           <TwitterShareButton
                           className="btn btn-circle mr-xs"
                           url={shareUrl}
                           title={shareContent}
                           >
                              <FontAwesome name="twitter" />
                           </TwitterShareButton>
                           <TelegramShareButton
                              className="btn btn-circle mr-xs"
                              url={shareUrl}
                              title={shareContent}
                           >
                              <FontAwesome name="telegram" />
                           </TelegramShareButton>
                           <WhatsappShareButton
                              className="btn btn-circle mr-xs"
                              url={shareUrl}
                              title={shareContent}
                              separator=" "
                           >
                              <FontAwesome name="whatsapp" />
                           </WhatsappShareButton>
                     </div>
                  </div>   
               {/*<Button className="btn mb-s" style={{ width: '400px'}}>Bagikan ke temanmu</Button>*/}
               </div>
               <div style={{marginTop: `30px`}}></div>
               <div  
                  style={{
                     display: 'flex',
                     justifyContent:'center',
                     alignItems:'center'
                  }} >
                  <Link to="/syarat-referral">
                        <h5 style={{ color: "green", textDecorationLine: 'underline' }}>Lihat Syarat dan Ketentuan </h5>
                  </Link>
               </div>
               <h5 
                  className="text-center mt-l " 
                  style={{ color: "black" }}
               > 
                  Total Benefit
               </h5>
               <div 
                  className="input-field" 
                  style={{
                     display: 'flex',
                     justifyContent:'center',
                     alignItems:'center'
                  }} 
               >
                  <div className="col s6">
                     <input disabled value={"Rp " + total_point} style={{ color: 'black', fontSize: '21px'}}/>
                  </div>
                  <div style={{ marginLeft:"0" }} className="col s4">
                     <a className="btn btn-sm" href="/detail-benefit">detail</a>
                  </div>
               </div>
               <h5 
                  className="text-center mt-l" 
                  style={{ color: "black" }}
               >
                  Apa saja yang bisa kamu dapatkan?
               </h5>
               <div
                  style={{
                     display: 'flex',
                     justifyContent:'center',
                     alignItems:'center'
                  }} 
               >
                  <h5 
                     id="skema" 
                     className="text-center mt-m" 
                     style={{ 
                        color: "black", 
                        fontWeight: "100", 
                        lineHeight:"30px" 
                     }}
                  >
                     Ajak teman-temanmu membeli kelas GETI Incubator <br/> menggunakan<b> kode referral-mu,</b><br/> serta dapatkan <b> benefit</b><br/> yang akan dikirimkan paling cepat dalam<br/><b> 1 hari kerja dan paling lama dalam 14 hari kerja.</b><br/> *Pengiriman<b> benefit </b>akan dikirimkan setiap hari kerja <br/> (kecuali hari Sabtu-Minggu dan hari libur nasional.)
                  </h5>
               </div>
               <h5
                  className="text-center mt-s" 
                  style={{ 
                     color: "black", 
                     fontWeight: "100", 
                     lineHeight:"30px" 
                  }}
                  ref="test"
               >
                  Berikut skemanya:
               </h5>
               <h5
                  className="text-center mt-s" 
                  style={{ 
                     color: "black", 
                     fontWeight: "100", 
                     lineHeight:"30px" 
                  }}
                  ref="test"
               >
                  Skema 1
               </h5>
               {this.getTableSkema1()}
               <h5
                  className="text-center mt-s" 
                  style={{ 
                     color: "black", 
                     fontWeight: "100", 
                     lineHeight:"30px" 
                  }}
                  ref="test"
               >
                  Skema 2
               </h5>
               {this.getTableSkema2()}
               <h4 
                  className="text-center mt-m" 
                  style={{ 
                     color: "black",
                  }}
               >
                  Bagaimana Caranya?
               </h4>
               <div style={{ display:"flex", justifyContent: "center" }}>
                  <ul className="experiences" >
                     <li>
                        Ajak temanmu, yang merupakan peserta Kartu<br/>
                        Prakerja, untuk menukarkan kode referral darimu<br/>
                        bersamaan dengan <b>kode voucher</b> dari pembelian<br/>
                        kelas di mitra platform (Bukalapak, Pintaria)
                     </li>
                     {/*<li>
                        Selain <b>benefit,</b> kamu juga bisa mendapatkan bonus<br/>
                        tambahan hingga jutaan rupiah tergantung jumlah<br/>
                        teman yang membeli kelas dengan memakai kode<br/>
                        referral kamu (lihat tabel di atas)
                     </li>*/}
                     <li>
                        Tunggu tim <b>GETI</b> Incubator mengirimkan benefit<br/>
                        sesuai dengan jumlah pengguna <b>kode referral</b><br/>
                        kamu dan sesuai dengan metode penerimaan <b>benefit</b><br/>
                        yang kamu pilih.
                     </li>
                  </ul>
               </div>
               <div  
                  style={{
                     display: 'flex',
                     justifyContent:'center',
                     alignItems:'center'
                  }} 
               >
                  <Link to="/syarat-referral" className="mt-s">
                        <h5 style={{ color: "green", textDecorationLine: 'underline' }}>Lihat Syarat dan Ketentuan </h5>
                  </Link>
               </div>
               <div  
                  style={{
                     display: 'flex',
                     justifyContent:'center',
                     alignItems:'center',
                     marginBottom:"10px"
                  }}
                  className="mt-l"
               >
                  <img style={{ height:"40px"}}src="/img/danger.png" alt="" />
                  <h5 
                     style={{ 
                        fontSize: "24px",
                        color: "black",                 
                        lineHeight:"30px",
                        marginBottom: "0px"
                     }}
                  >
                     Penting harap dibaca!
                  </h5>
               </div>
               <div  
                  style={{
                     display: 'flex',
                     justifyContent:'center',
                     alignItems:'center'
                  }}
               >
                  <h4 
                     style={{ 
                        color: "black",
                        fontWeight: "100",               
                        lineHeight:"30px"  
                     }}
                     className="text-center"
                  >
                     Informasi tambahan mengenai cara
                     penambahan benefit
                  </h4>
               </div>
               <table 
                  className="mt-s" 
               >
                  <thead style={{backgroundColor:'#0D47A1'}}>
                     <tr>
                        <th className="text-center text-white pad-s">Pengiriman benefit ke rekening bank kamu</th>
                     </tr>
                  </thead>
                  <tbody>
                     <tr style={{ backgroundColor:'#2196F3'}}>
                        <td className="text-center text-white">
                           Pastikan data nomor rekening benar
                           sesuai dengan data penerima.
                        </td>
                     </tr>
                     <tr style={{ backgroundColor:'#03A9F4' }}>
                        <td className="text-center text-white">Pengiriman akan dikirim setiap 1 hari kerja.</td>
                     </tr>
                     <tr style={{ backgroundColor:'#2196F3'}}>
                        <td className="text-center text-white">
                           Jika pengiriman gagal, periksa kembali nomor rekening dan nama kamu
                           apakah sudah terisi dengan benar.
                        </td>
                     </tr>
                  </tbody>
               </table>
               <table 
                  className="mt-s" 
               >
                  <thead style={{backgroundColor:'#0D47A1'}}>
                     <tr>
                        <th className="text-center text-white pad-s">Info status dan bantuan lebih lanjut</th>
                     </tr>
                  </thead>
                  <tbody>
                     <tr style={{ backgroundColor:'#2196F3'}}>
                        <td className="text-center text-white">
                        Status pengiriman dapat dilihat di halaman &nbsp;
                        <Link to="detail-benefit" style={{ color: "green", textDecorationLine: 'underline' }}>Total Benefit</Link> 
                        </td>
                     </tr>
                     <tr style={{ backgroundColor:'#03A9F4' }}>
                        <td className="text-center text-white">Info lebih lanjut bisa hubungi 0811 9309 114 atau klik link &nbsp;
                        <Link to="#" style={{ color: "green", textDecorationLine: 'underline' }}>ini</Link>
                     </td>
                     </tr>
                  </tbody>
               </table>
            </Row>
      )

   }
}
class Bonus extends React.Component {

   getTableSkema1 = () => {
      let bonus = this.props.bonus
      var tableSkema1 = (
         <table 
            className="mt-s"
         >
            <thead style={{backgroundColor:'#303b92'}}>
               <tr>
                  <th className="text-center text-white">Harga Kelas</th>
                  <th className="text-center text-white">Pulsa yang kamu dapatkan</th>
               </tr>
            </thead>
            {bonus.map((bonus,index)=>{
               if(bonus.schema == 1){
                  if ( index%2 == 0){
                     return(
                        <tbody>
                           <tr style={{ backgroundColor:'#546dfc'}}>
                              <td style={{ width:'300px'}}className="text-center text-white">Rp {bonus.price_from} - Rp {bonus.price_to}</td>
                              <td style={{ width:'300px'}}className="text-center text-white">Rp {bonus.buyers_point}</td>
                           </tr>
                        </tbody>
                     )
                  } else {
                     return(
                        <tbody>
                           <tr style={{ backgroundColor:'#4a65d8'}}>
                              <td className="text-center text-white">Rp {bonus.price_from} - Rp {bonus.price_to}</td>
                              <td className="text-center text-white">Rp {bonus.buyers_point}</td>
                           </tr>
                        </tbody>
                     )
                  }
               }
            })}
         </table>
      )
      return tableSkema1
   }

   getTableSkema2 = () => {
      let bonus = this.props.bonus
      var tableSkema2 = (
         <table 
            className="mt-s"
         >
            <thead style={{backgroundColor:'#303b92'}}>
               <tr>
                  <th className="text-center text-white">Harga Kelas</th>
                  <th className="text-center text-white">Uang yang kamu dapatkan</th>
               </tr>
            </thead>
            {bonus.map((bonus,index)=>{
               if(bonus.schema == 2){
                  if ( index%2 == 0){
                     return(
                        <tbody>
                           <tr style={{ backgroundColor:'#546dfc'}}>
                              <td style={{ width:'300px'}}className="text-center text-white">Rp {bonus.price_from} - Rp {bonus.price_to}</td>
                              <td style={{ width:'300px'}}className="text-center text-white">Rp {bonus.buyers_point}</td>
                           </tr>
                        </tbody>
                     )
                  } else {
                     return(
                        <tbody>
                           <tr style={{ backgroundColor:'#4a65d8'}}>
                              <td className="text-center text-white">Rp {bonus.price_from} - Rp {bonus.price_to}</td>
                              <td className="text-center text-white">Rp {bonus.buyers_point}</td>
                           </tr>
                        </tbody>
                     )
                  }
               }
            })}
         </table>
      )
      return tableSkema2
   }

   render() {
      let referral = this.props.referral
      let total_point = this.props.total_point
      let bonus = this.props.bonus
      let no_handphone = this.props.no_handphone
      let total_pulsa = this.props.total_pulsa
      return(
         <Row>
            <div style={{ display:"flex", justifyContent: "center", marginTop: "40px" }}>
             <img style={{ width:"150px" }}src="img/white-label/logo/logo.png" alt="" /> 
            </div>
         <h4 className="text-center mt-m" style={{ color: "black" }}>Bagikan kode referralmu dan dapatkan <br />jutaan rupiah tiap minggunya!</h4>
         <h5 
            className="text-center mt-l " 
            style={{ color: "black" }}
            >
               Total benefit pulsa yang didapat
         </h5>
         <div 
            className="input-field" 
            style={{
               display: 'flex',
               justifyContent:'center',
               alignItems:'center'
            }} 
         >
            <div className="col s6">
               <input disabled value={"Rp " + total_pulsa} style={{color: 'black', fontSize: '21px'}}/>
            </div>
            <div style={{ marginLeft:"0" }} className="col s4">
               <a className="btn btn-sm" href="/detail-pulsa">detail</a>
            </div>
         </div>
         <h5 
            className="text-center mt-l " 
            style={{ color: "black" }}
         > 
            Penerimaan pulsa melalui nomor.
         </h5>
         {
            !no_handphone ? 
            <div>
               <div 
                  className="input-field" 
                  style={{
                     display: 'flex',
                     justifyContent:'center',
                     alignItems:'center'
                  }} 
               >
                  <input disabled value={no_handphone} style={{ width: '400px', color: 'black', fontSize: '21px'}}/>
               </div>
               <div  
                  style={{
                     display: 'flex',
                     justifyContent:'center',
                     alignItems:'center',
                     marginBottom:"10px"
                  }}
               >
                  <img style={{ height:"20px"}}src="/img/danger.png" alt="" />
                  <p 
                     style={{
                        color: "black",
                        marginBottom: "0px",
                        marginTop: "0px"
                     }}
                  >
                     Nomor belum terisi!
                  </p>
               </div>
               <div style={{
                     display: 'flex',
                     justifyContent:'center',
                     alignItems:'center'
                  }}
               >
                  <Row style={{
                           display: "block",
                           width: "400px",
                           marginTop:"0", 
                           backgroundColor:"#303b92", 
                           border: "1px solid", 
                           borderColor:"#c5ffdc",
                        }}
                        className="align-items-top mb-m">
                           <p style={{ color:"#fff",marginTop:"0", marginBottom:"0" }} className="text-center">
                              Mohon isi dan simpan nomor handphone kamu<br/>
                              agar proses pengiriman benefit bisa dilakukan.
                           </p>
                  </Row>
               </div>
            </div>
               
            :
               <div 
                  className="input-field" 
                  style={{
                     display: 'flex',
                     justifyContent:'center',
                     alignItems:'center'
                  }} 
               >
                  <input disabled value={no_handphone} style={{ width: '400px', color: 'black', fontSize: '21px'}}/>
               </div>
         }
         <h5 
            className="text-center mt-m" 
            style={{ color: "black" }}
         >
            Apa saja yang bisa kamu dapatkan?
         </h5>
         <div
            style={{
               display: 'flex',
               justifyContent:'center',
               alignItems:'center'
            }} 
         >
            <h5 
               id="skema-2"
               className="text-center mt-m" 
               style={{ 
                  color: "black", 
                  fontWeight: "100", 
                  lineHeight:"30px" 
               }}
            >
                  Untuk pengguna, kamu bisa mendapatkan pulsa dengan<br/>
                  menggunakan kode referral dari temanmu! Proses<br/>
                  pengiriman pulsa akan dikerjakan selama <b>1 hari kerja</b>
            </h5>
         </div>
         <h5
            className="text-center mt-s" 
            style={{ 
               color: "black", 
               fontWeight: "100", 
               lineHeight:"30px" 
            }}
            ref="test"
         >
            Berikut skemanya:
         </h5>
         <h5
            className="text-center mt-s" 
            style={{ 
               color: "black", 
               fontWeight: "100", 
               lineHeight:"30px" 
            }}
            ref="test"
         >
            Skema 1
         </h5>
         {this.getTableSkema1()}
         <h5
            className="text-center mt-s" 
            style={{ 
               color: "black", 
               fontWeight: "100", 
               lineHeight:"30px" 
            }}
            ref="test"
         >
            Skema 2
         </h5>
         {this.getTableSkema2()}
         <h4 
            className="text-center mt-m" 
            style={{ 
               color: "black",
            }}
         >
            Bagaimana Caranya?
         </h4>
         <div style={{ display:"flex", justifyContent: "center" }}>
            <ul className="experiences" >
               <li>
                  Minta temanmu pengguna GETI Incubator<br/>
                  untuk membagikan kode referralnya
               </li>
               <li>
                  Tukarkan kode referral dari temanmu bersamaan<br/>
                  dengan kode voucher dari pembelian kelas<br/>
                  di mitra platform<br/>
                  (Bukalapak, Tokopedia, Pintaria, Pijar Mahir, Kariermu)
               </li>
               <li>
                  Kamu akan mendapatkan pulsa Rp25.000<br/>
                  setiap membeli kelas dengan harga di atas Rp500.000
               </li>
               <li>
                  Tunggu tim GETI Incubator mengirimkan pulsa<br/>
                  sesuai dengan nomor Handphone yang tercantum
               </li>
            </ul>
         </div>
         <div  
            style={{
               display: 'flex',
               justifyContent:'center',
               alignItems:'center'
            }} 
         >
            <Link to="/syarat-referral" className="mt-s">
                  <h5 style={{ color: "green", textDecorationLine: 'underline' }}>Lihat Syarat dan Ketentuan </h5>
            </Link>
         </div>
         <div  
            style={{
               display: 'flex',
               justifyContent:'center',
               alignItems:'center',
               marginBottom:"10px"
            }}
            className="mt-l"
         >
            <img style={{ height:"40px"}}src="/img/danger.png" alt="" />
            <h5 
               style={{ 
                  fontSize: "24px",
                  color: "black",                 
                  lineHeight:"30px",
                  marginBottom: "0px"
               }}
            >
               Penting harap dibaca!
            </h5>
         </div>
         <div  
            style={{
               display: 'flex',
               justifyContent:'center',
               alignItems:'center'
            }}
         >
            <h4 
               style={{ 
                  color: "black",
                  fontWeight: "100",               
                  lineHeight:"30px"  
               }}
               className="text-center"
            >
               Informasi tambahan mengenai cara
               transfer pulsa
            </h4>
         </div>
         <table 
            className="mt-s" 
         >
            <thead style={{backgroundColor:'#0D47A1'}}>
               <tr>
                  <th className="text-center text-white pad-s">Pengiriman benefit pulsa ke nomor kamu</th>
               </tr>
            </thead>
            <tbody>
               <tr style={{ backgroundColor:'#2196F3'}}>
                  <td className="text-center text-white">
                     Pastikan data nomor HP benar
                     sesuai dengan data penerima.
                  </td>
               </tr>
               <tr style={{ backgroundColor:'#03A9F4' }}>
                  <td className="text-center text-white">Pengiriman akan dikirim setiap 1 hari kerja.</td>
               </tr>
               <tr style={{ backgroundColor:'#2196F3'}}>
                  <td className="text-center text-white">
                     Jika pengiriman pulsa gagal, periksa kembali nomor HP kamu
                     apakah sudah terisi dengan benar.
                  </td>
               </tr>
            </tbody>
         </table>
         <table 
            className="mt-s" 
         >
            <thead style={{backgroundColor:'#0D47A1'}}>
               <tr>
                  <th className="text-center text-white pad-s">Info status dan bantuan lebih lanjut</th>
               </tr>
            </thead>
            <tbody>
               <tr style={{ backgroundColor:'#2196F3'}}>
                  <td className="text-center text-white">
                  Status pengiriman dapat dilihat di halaman &nbsp;
                  <Link to="detail-pulsa" style={{ color: "green", textDecorationLine: 'underline' }}>Total Benefit Pulsa</Link> 
                  </td>
               </tr>
               <tr style={{ backgroundColor:'#03A9F4' }}>
                  <td className="text-center text-white">Info lebih lanjut bisa hubungi 0811 9309 114 atau klik link &nbsp;
                  <Link to="#" style={{ color: "green", textDecorationLine: 'underline' }}>ini</Link>
               </td>
               </tr>
            </tbody>
         </table>
      </Row>
      )
   }
}

export default Referral;


// WEBPACK FOOTER //
// ./src/components/Referral/Referral.js